import { useQuery } from '@tanstack/react-query'
import { fetchGuaranteesV2 } from './http'
import { fromGuaranteeResponses } from '../models/mapper'
import { Guarantee } from '../models/types'
import { QueryKeys } from '../../../key-registry'

export async function fetchGuarantees(
  params: { transitOperationId: number },
  opts?: { signal?: AbortSignal },
): Promise<Guarantee[]> {
  const responses = await fetchGuaranteesV2(params, opts)

  return fromGuaranteeResponses(responses)
}

export function useFetchGuarantees(transitOperationId: number | null) {
  return useQuery({
    queryKey: QueryKeys.guarantee.list({ transitOperationId }),
    enabled: !!transitOperationId,
    queryFn: ({ signal }) => fetchGuarantees({
      transitOperationId: transitOperationId as number,
    }, { signal }),
  })
}
